import {
    Box,
    Drawer,
    DrawerContent,
    DrawerCloseButton,
    DrawerOverlay,
    useDisclosure,
} from "@chakra-ui/react"

import PageRoutes from "./routes/Routes";
import MenuComponent from "./components/MenuComponent";
import Navbar from "./components/Navbar";
import { useLocation } from "react-router";
import './main.css';
import { initHttp } from "./http/common";
import { useEffect, useState } from "react";
import ModernLoader from "./components/ModernLoader";
import Footer from "./components/Footer";

export default function App() {
    const { pathname } = useLocation();
    const [settingUp, setSettingUp] = useState(true);
    const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();

    useEffect(() => {
        onInitApp();
    }, [])

    const onInitApp = async () => {
        await initHttp();
        setSettingUp(false);
    }

    const sidebarWidth = isSidebarCollapsed ? "72px" : "280px";

    // Close drawer when navigating
    useEffect(() => {
        onClose();
    }, [onClose, pathname]);

    return (
        <>
            {settingUp ?
                <ModernLoader message="Setting up Application..." /> :

                <Box minH="100vh" bg="#f4f1ec">
                    {pathname !== '/login' && (
                        <>
                            {/* Sidebar for Desktop */}
                            <Box
                                display={{ base: 'none', lg: 'block' }}
                                w={sidebarWidth}
                                minW={sidebarWidth}
                                h={"100vh"}
                                background={"#1b73e8"}
                                position="fixed"
                                left={0}
                                top={0}
                                overflow="hidden"
                                transition="width 0.25s ease, min-width 0.25s ease"
                                zIndex={100}
                            >
                                <MenuComponent
                                    isCollapsed={isSidebarCollapsed}
                                    onToggleCollapse={() => setSidebarCollapsed(!isSidebarCollapsed)}
                                />
                            </Box>

                            {/* Drawer for Mobile/Tablet */}
                            <Drawer
                                isOpen={isOpen}
                                placement="left"
                                onClose={onClose}
                                size="xs"
                            >
                                <DrawerOverlay />
                                <DrawerContent bg="#1b73e8">
                                    <DrawerCloseButton color="white" zIndex="1001" size="lg" />
                                    <MenuComponent />
                                </DrawerContent>
                            </Drawer>

                            {/* Top Navbar for Mobile/Tablet */}
                            <Navbar onOpen={onOpen} />
                        </>
                    )}

                    <Box
                        ml={pathname !== '/login' ? { base: 0, lg: sidebarWidth } : 0}
                        p={pathname === '/login' ? "0px" : { base: "16px", md: "24px" }}
                        transition="margin-left 0.25s ease"
                        minH="100vh"
                        display="flex"
                        flexDirection="column"
                    >
                        <Box flex="1">
                            <PageRoutes />
                        </Box>
                        {pathname !== '/login' && <Footer />}
                    </Box>
                </Box>
            }
        </>
    );
}
